export interface Environment {
    production: boolean;
    version: string;
    stage: string;
    api: string;
    audience: string;
    skipApiCheck: boolean;
    copyright: {
        year: number;
        company: string;
        url: string;
        privacyUrl: string;
        termsUrl: string;
        contactUrl: string;
    };
    config: {
        [key: string]: any;
    };
    apiUrl: string;
    googleClientId: string;
    appleClientId: string;
    appleRedirectUri: string;
}

export const environment = {
    production: false,
    version: '1.0.0',
    stage: 'local',
    api: 'https://api.contemplate.life/api/v1',
    audience: 'https://stage.contemplate.life',
    skipApiCheck: false,
    copyright: {
        year: new Date().getFullYear(),
        company: 'Contemplate',
        url: 'https://contemplate.life',
        privacyUrl: 'https://contemplate.life/privacy',
        termsUrl: 'https://contemplate.life/terms',
        contactUrl: 'https://contemplate.life/contact'
    },
    config: {
        // Add any additional configuration here
    },
    googleClientId: '974918814681-sjk65qtkt37hl5t4s87fvur2mdha1i5t.apps.googleusercontent.com',
    appleClientId: 'com.contemplate.life',
    appleRedirectUri: 'https://contemplate.life/auth/apple/callback',
    stripePublicKey: 'pk_live_51IjlcWSEIRI6P3kdhFrNY2QgWXs7n2YGCRn1MMc0oauMSD7UkKbaNCG0W4RkrWn1vneQF3sJosoKIPLqjkqt31MJ00puX5NGxC',
    mindFitnessDefaultDataMode: 'live' as 'demo' | 'live',
    recaptchaSiteKey: '6LdU7qEtAAAAALwAdIACCSISMEiMPEgcZ5GV6jXV'
};
